export const shortDateTimeFormat = 'dd.MM.yyyy HH:mm';
export const oldShortDateTimeFormat = 'yyyy-MM-dd HH:mm';
export const oldFullDateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
export const formDatePickerFormat = 'yyyy-MM-dd';
export const shortDateTime = 'dd.MM.yyyy';
export const oldShortDateTimeFormatUnlimYears = 'yyyyy-MM-dd HH:mm';
